<template>
  <div class="loading-container">
    <div class="loading-spinner">
      <svg class="animate-spin h-8 w-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="mt-2 text-sm text-gray-600">Loading dashboard data...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
}
</script>

<style scoped>
.loading-container {
  @apply flex items-center justify-center;
  min-height: 26rem;
  background-color: #f8fafc; /* Add light background color for light theme */
}

.loading-spinner {
  @apply flex flex-col items-center;
}

/* Add dark mode styles */
:root[data-theme="dark"] .loading-container {
  background-color: #1e293b; /* Dark background for dark theme */
}

:root[data-theme="dark"] .loading-spinner p {
  color: rgba(255, 255, 255, 0.7);
}
</style> 